import { ComponentType } from 'react';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SignupPage from './pages/SignupPage';
import CallbackPage from './pages/CallbackPage';
import WelcomeScreen from './pages/WelcomeScreen';
import Dashboard from './pages/Dashboard';
import TeamFocusSessionPage from './pages/TeamFocusSessionPage';
import AccountSettings from './pages/AccountSettings';
import SubscriptionPage from './pages/SubscriptionPage';
import WorkLogAnalytics from './pages/WorkLogAnalytics';
import InvoicePage from './pages/InvoicePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import BlogPage from './pages/BlogPage';
import AboutPage from './pages/AboutPage';


export interface RouteConfig {
  name: string;
  path: string;
  component: ComponentType<any>;
  requiresAuth?: boolean;
  isAuthRoute?: boolean; // Routes that should redirect if user is already authenticated
  exact?: boolean;
  hideHeader?: boolean;
}

export const routes: RouteConfig[] = [
  {
    name: 'Landing',
    path: '/',
    component: LandingPage,
    exact: true,
  },
  {
    name: 'Login',
    path: '/login',
    component: LoginPage,
    isAuthRoute: true,
  },
  {
    name: 'Forgot Password',
    path: '/forgot-password',
    component: ForgotPasswordPage,
    isAuthRoute: true,
  },
  {
    name: 'Reset Password',
    path: '/reset-password',
    component: ResetPasswordPage,
    isAuthRoute: true,
  },
  {
    name: 'Signup',
    path: '/signup',
    component: SignupPage,
    isAuthRoute: true,
  },
  {
    name: 'Callback',
    path: '/callback',
    component: CallbackPage,
  },
  {
    name: 'Welcome',
    path: '/welcome',
    component: WelcomeScreen,
    requiresAuth: true,
  },
  {
    name: 'Dashboard',
    path: '/dashboard',
    component: Dashboard,
    requiresAuth: true,
  },
  // {
  //   name: 'Team Mode',
  //   path: '/team',
  //   component: TeamModePage,
  //   requiresAuth: true,
  // },
  {
    name: 'Team Focus Session',
    path: '/team/:teamId',
    component: TeamFocusSessionPage,
    requiresAuth: true,
    hideHeader: true,
  },
  {
    name: 'Account Settings',
    path: '/account-settings',
    component: AccountSettings,
    requiresAuth: true,
  },
  {
    name: 'Subscription',
    path: '/subscription',
    component: SubscriptionPage,
    requiresAuth: true,
  },
  {
    name: 'Work Log Analytics',
    path: '/worklog',
    component: WorkLogAnalytics,
    requiresAuth: true,
  },
  {
    name: 'Invoice',
    path: '/invoice',
    component: InvoicePage,
    requiresAuth: true,
  },
  {
    name: 'Privacy Policy',
    path: '/privacy-policy',
    component: PrivacyPolicy,
  },
  {
    name: 'Blog',
    path: '/blog',
    component: BlogPage,
  },
  {
    name: 'Blog Post',
    path: '/blog/:postId',
    component: BlogPage,
  },
  {
    name: 'About Us',
    path: '/about',
    component: AboutPage,
  },
];

